import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-elements',
  templateUrl: './elements.component.html',
  styleUrls: ['./elements.component.scss']
})

/**
 * Elements component - handling the form elements with navbar and content
 */
export class ElementsComponent implements OnInit {

  // bread crumb items
  breadCrumbItems: Array<any>;

  constructor() { }

  ngOnInit() {
    // tslint:disable-next-line: max-line-length
    this.breadCrumbItems = [{ label: 'Aivis', path: '/' }, { label: 'Forms', path: '/' }, { label: 'Form elements', path: '/', active: true }];
  }
}
